export default __webpack_public_path__ + "static/media/factors-transport.96ea9858.jpg";